module.exports = __webpack_public_path__ + "img/ahahah.d193ca4a.gif";